<template>
    <!--<div class="position-relative">
        <div class="dropdown" v-if="isLoggedIn">
            <a href="#" class="dropdown-toggle nav-link" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window">
                <i class="fa fa-user mr-1 d-sm-none" aria-hidden="true"></i>
                <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.loginHello", {"username": username }) }}</span>
            </a>
            <div class="dropdown-menu small m-0 p-0 mw-100">
                <div class="list-group" aria-labelledby="accountMenuList" >
                    <a :href="$ceres.urls.myAccount" class="list-group-item small"><i class="fa fa-user"></i> {{ $translate("Ceres::Template.loginMyAccount") }}</a>
                    <a href="#" class="list-group-item small" v-logout><i class="fa fa-sign-out"></i> {{ $translate("Ceres::Template.loginLogout") }}</a>
                </div>
            </div>
        </div>
        <div v-if="!isLoggedIn">
            <a class="nav-link" v-if="showLogin" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal(); unmarkInputFields();">
                <i class="fa fa-user mr-1" aria-hidden="true"></i>
                <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.login") }}</span>
            </a>
            <template v-if="showRegistration">
                <span class="pipe" v-if="!showLogin"></span>
                <a class="nav-link" :href="isRegister ? 'javascript:void(0)' : '#registration'" :data-toggle="isRegister ? false : 'modal'"  @click="createRegisterModal(); unmarkInputFields();" >
                    <i class="fa fa-user-plus mr-1" aria-hidden="true"></i>
                    <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.loginRegister") }}</span>
                </a>
            </template>
        </div>
    </div>-->
    <div id="login-change">
        <div class="dropdown" v-if="isLoggedIn">
            <input type="hidden" value="true" id="is-logged-in">
            <div>
                <a href="#" class="dropdown-toggle" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <!--<img :src="pluginPath + '/images/svg/login-icon.svg'" class="pull-left">
                    <div class="pull-left header__user-playground-account hidden-md-down">
                        <div><b>Mein Konto</b></div>
                    </div>-->
                    <div class="login-change__user-icon">
                        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             viewBox="0 0 513.323 513.323" style="enable-background:new 0 0 513.323 513.323;" xml:space="preserve">
                            <g>
                                <g>
                                    <path d="M256.661,257.323c-135.275,0-245.333,110.059-245.333,245.333c0,5.888,4.779,10.667,10.667,10.667
                                        s10.667-4.779,10.667-10.667c0-123.52,100.48-224,224-224s224,100.48,224,224c0,5.888,4.779,10.667,10.667,10.667
                                        c5.888,0,10.667-4.779,10.667-10.667C501.995,367.36,391.936,257.323,256.661,257.323z"/>
                                </g>
                            </g>
                                                        <g>
                                <g>
                                    <path d="M256.661,0c-64.683,0-117.333,52.629-117.333,117.333s52.651,117.333,117.333,117.333s117.333-52.629,117.333-117.333
                                        S321.344,0,256.661,0z M256.661,213.333c-52.928,0-96-43.072-96-96s43.072-96,96-96c52.928,0,96,43.072,96,96
                                        S309.589,213.333,256.661,213.333z"/>
                                </g>
                            </g>
                        </svg>

                    </div>
                    <div>Konto</div>
                </a>
                <div class="account-menu dropdown-menu dropdown-menu-right small">
                    <div class="list-group" aria-labelledby="accountMenuList" >
                        <a :href="$ceres.urls.myAccount" class="list-group-item small">{{ $translate("Ceres::Template.loginMyAccount") }}</a>
                        <a href="#" class="list-group-item small" v-logout>{{ $translate("Ceres::Template.loginLogout") }}</a>
                        <a :href="$ceres.urls.wishList" class="list-group-item small">Merkliste</a>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!isLoggedIn">
            <input type="hidden" value="false" id="is-logged-in">
            <div data-toggle="modal" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'"  @click="createLoginModal(); unmarkInputFields();" :aria-label="$translate('Ceres::Template.login')">
                <div class="login-change__user-icon">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         viewBox="0 0 513.323 513.323" style="enable-background:new 0 0 513.323 513.323;" xml:space="preserve">
                    <g>
                      <g>
                        <path d="M256.661,257.323c-135.275,0-245.333,110.059-245.333,245.333c0,5.888,4.779,10.667,10.667,10.667
                          s10.667-4.779,10.667-10.667c0-123.52,100.48-224,224-224s224,100.48,224,224c0,5.888,4.779,10.667,10.667,10.667
                          c5.888,0,10.667-4.779,10.667-10.667C501.995,367.36,391.936,257.323,256.661,257.323z"/>
                      </g>
                    </g>
                                            <g>
                      <g>
                        <path d="M256.661,0c-64.683,0-117.333,52.629-117.333,117.333s52.651,117.333,117.333,117.333s117.333-52.629,117.333-117.333
                          S321.344,0,256.661,0z M256.661,213.333c-52.928,0-96-43.072-96-96s43.072-96,96-96c52.928,0,96,43.072,96,96
                          S309.589,213.333,256.661,213.333z"/>
                      </g>
                    </g>
                    </svg>

                </div>
                <div>Login</div>
                <!--<a data-toggle="modal" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'"  @click="createLoginModal(); unmarkInputFields();">
                <img :src="pluginPath + '/images/svg/login-icon.svg'" class="pull-left">
                <div class="pull-left header__user-playground-account hidden-md-down">
                    <h5 class="header__main-content-heading">
                        <b>
                            <a>Login</a>
                        </b>
                    </h5>
                    <div>Mein Konto</div>
                </div>
                </a>-->
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "ceres/app/services/ApiService";
import ValidationService from "ceres/app/services/ValidationService";
import { mapGetters, mapActions } from "vuex";

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true
        },
        showLogin: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        pluginPath(){
            return App.pluginPath;
        },

        ...mapGetters([
           "username",
           "isLoggedIn"
        ])
    },

    data()
    {
        return {
            isLogin: App.templateType === "login",
            isRegister: App.templateType === "register"
        };
    },

    methods: {
        unmarkInputFields()
        {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal()
        {
            this.loadComponent("login-modal");
        },

        createRegisterModal()
        {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
